import GS from '../grafsync/grafsync';
import AssociatedPropertyDisplay from '../application-core/AssociatedPropertyDisplay';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../core/style/gstheme';
import { makeCancelable } from '../core/utils/utils';

class AdditionalDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            propsList: []
        };
        this.cancellable = null;
    }

    componentDidMount() {
        this.collectData();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.data._version !== state._version) {
            return {
                isLoading: false,
                _version: props.data._version,
            };
        }
        return null;
    }

    componentDidUpdate() {
        if (!this.state.isErrored && this.state.pathLoading === true) {
            this.collectData();
        }
    }

    loadData(iris, options) {
        this.cancellable = makeCancelable(GS.loadData(iris, options, this.props.graph));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    collectData() {
        if (this.state.isLoading) return;
        // We load ALL the necessary data at this level in the tree in one API call to avoid unnecessary calls and to sort
        this.setState({ isLoading: true }, () => {
            this.loadData(this.props.availableAnnotationProperty)
                .promise
                .then(() => {
                    if (this.cancellable && this.cancellable.isCancelled()) return;
                    let propsList = this.props.availableAnnotationProperty;
                    propsList.sort((a, b) => {
                        const aData = GS.isLoaded(a, this.props.graph) ? GS.data(a, this.props.graph) : null;
                        const bData = GS.isLoaded(b, this.props.graph) ? GS.data(b, this.props.graph) : null;
                        const labelA = aData && aData.label[this.props.defaultLang] ?
                            aData.label[this.props.defaultLang].toLowerCase()
                            :
                            aData && aData.label["und"] ?
                                aData && aData.label["und"].toLowerCase()
                                :
                                a;
                        const labelB = bData && bData.label[this.props.defaultLang] ?
                            bData.label[this.props.defaultLang].toLowerCase()
                            :
                            bData && bData.label["und"] ?
                                bData && bData.label["und"].toLowerCase()
                                :
                                b;
                        if (labelA < labelB) return -1;
                        return 1;
                    });
                    if (this.cancellable && !this.cancellable.isCancelled()) {
                        this.setState({ isLoading: false, propsList });
                    }
                })
                .catch((e) => {
                    if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e, isLoading: false });
                });
        });
    }

    render() {

        const { data, viewLang, defaultLang, projectLang, graph, isReadOnly, addNewResource, context, useWorkflow,
            onDelete, addNewLiteral, onUpdate, addNewTypedLiteral, projectIRI, ontologyIRI } = this.props;
        const { propsList } = this.state;

        const associatedProjectGraph = graph;

        return (
            propsList && propsList.length > 0 &&
            propsList.map(ap =>
                <AssociatedPropertyDisplay
                    key={ap}
                    title=" a value"
                    resourceData={data}
                    sourceComponent={ontologyIRI}
                    viewLang={viewLang}
                    useWorkflow={useWorkflow}
                    projectLang={projectLang}
                    projectType="OntologyProject"
                    projectIRI={projectIRI}
                    overrideNullDatatype={true}
                    resourceClasses={[]}
                    context={context}
                    searchClasses={[
                        "http://www.w3.org/2002/07/owl#Class",
                        "http://www.w3.org/2002/07/owl#DatatypeProperty",
                        "http://www.w3.org/2002/07/owl#ObjectProperty",
                        "http://www.w3.org/2002/07/owl#AnnotationProperty",
                        "http://www.w3.org/2002/07/owl#NamedIndividual",
                        "http://www.w3.org/2000/01/rdf-schema#Datatype"
                    ]}
                    addNewResource={addNewResource}
                    addNewLiteral={addNewLiteral}
                    addNewTypedLiteral={addNewTypedLiteral}
                    isReadOnly={isReadOnly}
                    onAssociatedPropertyDelete={onDelete}
                    onAssociatedPropertyUpdate={onUpdate}
                    id={ap}
                    handleNotAvailable={true}
                    graph={associatedProjectGraph}
                    projectGraph={graph}
                    includeExistingResource={addNewResource}
                    associatedProjectGraph={associatedProjectGraph}
                    defaultLang={defaultLang} />
            )
        );
    }
}

AdditionalDetail.defaultProps = {
    enable: []
};

AdditionalDetail.propTypes = {
    classes: PropTypes.object,
    projectIRI: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    context: PropTypes.string.isRequired,
    addNewTypedLiteral: PropTypes.func.isRequired,
    addNewLiteral: PropTypes.func.isRequired,
    viewLang: PropTypes.string,
    isReadOnly: PropTypes.bool,
    ontologyIRI: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    projectLang: PropTypes.array.isRequired,
    addNewResource: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired,
    useWorkflow: PropTypes.bool,
    availableAnnotationProperty: PropTypes.array
};

export default withStyles(styles)(AdditionalDetail);